import { createFileRoute, Link } from "@tanstack/react-router";
import { PublicNav } from "@/components/site/PublicNav";
import { Footer } from "@/components/site/Footer";

export const Route = createFileRoute("/help")({
  head: () => ({
    meta: [
      { title: "Help & support — Shields" },
      {
        name: "description",
        content:
          "How bookings, bids, Shields Credits, cancellations and issues work, plus our privacy and accessibility commitments.",
      },
      { property: "og:title", content: "Help & support — Shields" },
      { property: "og:description", content: "Answers about bookings, bids, credits and cancellations." },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary" },
    ],
  }),
  component: HelpPage,
});

const SECTIONS = [
  {
    title: "Bookings and prices",
    body: "You describe the job and partners send bids in pounds. A guide range may be shown when we have enough real local data — a guide is never a final quote. You pay the price you accept; Shields takes no commission.",
  },
  {
    title: "Shields Credits",
    body: "Shields Credits are platform credits used by partners to win work. They have no cash value, cannot be withdrawn and cannot be transferred between users. Viewing offers, declining and unsuccessful bids are always free.",
  },
  {
    title: "Cancellations",
    body: "You can cancel a booking any time before a partner is assigned. After assignment, contact your partner through Shields messaging to agree changes; repeated late cancellations may be reviewed by our team.",
  },
  {
    title: "Problems with a job",
    body: "Report an issue from your booking and our team will review the evidence. Fault, refunds and account actions are always decided by a person, never automatically.",
  },
  {
    title: "Your data",
    body: "Partners only see your exact address and contact details after you choose them. Before that they see a privacy-safe summary and your general area. You can request a copy or deletion of your data from your account page.",
  },
  {
    title: "Accessibility",
    body: "We aim for WCAG 2.2 AA: keyboard support, visible focus, labelled fields and reduced-motion support. If something is hard to use, tell us and we'll fix it.",
  },
];

function HelpPage() {
  return (
    <div className="min-h-screen">
      <PublicNav />
      <main className="section-pad mx-auto max-w-3xl py-14">
        <h1 className="text-3xl font-bold sm:text-4xl">Help &amp; support</h1>
        <p className="mt-3 text-muted-foreground">
          Straight answers in plain English. Signed in? The fastest route is your{" "}
          <Link to="/account" className="font-semibold text-primary underline">account page</Link>.
        </p>
        <div className="mt-10 space-y-4">
          {SECTIONS.map((s) => (
            <section key={s.title} className="card-surface p-6">
              <h2 className="font-display text-lg font-bold">{s.title}</h2>
              <p className="mt-2 text-sm text-muted-foreground">{s.body}</p>
            </section>
          ))}
        </div>
      </main>
      <Footer />
    </div>
  );
}
